













































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import WindowButton from '@/modules/shared/components/WindowButton'
import LocaleSwitcher from '@/modules/shared/components/LocaleSwitcher'
import AppButton from '@/modules/shared/components/AppButton'
import { getModule } from 'vuex-module-decorators'
import layoutStore from '@/modules/shared/layout.store'
import userStore from '@/modules/auth/auth.store'
import venueStore from '@/modules/venue/venue.store'
import tournamentStore from '@/modules/tournament/tournament.store'
import { isElectron } from '@/utils/electron'
import { minimize, quit } from '@/utils/window'
import HelpDialog from '@/modules/shared/components/TheAppBar/HelpDialog'
import NotificationCenter from '@/modules/shared/components/NotificationCenter'
import GetMobileAppDialog from '@/modules/shared/components/GetMobileAppDialog'
import LiveChatAPI from '@/utils/livechat'
import { IpcRendererEvent } from 'electron'

@Component({
  components: {
    HelpDialog,
    WindowButton,
    LocaleSwitcher,
    AppButton,
    NotificationCenter,
    GetMobileAppDialog
  },
  filters: {
    userNickname(nickname: string) {
      // if (nickname.length > 10) return nickname.substring(0, 10) + '...'
      return nickname
    }
  }
})
export default class TheAppBar extends Vue {
  userModule = getModule(userStore, this.$store)
  venueModule = getModule(venueStore, this.$store)
  layoutModule = getModule(layoutStore, this.$store)
  tournamentModule = getModule(tournamentStore, this.$store)

  isHelpDialogVisible: boolean = false
  isMobileAppDialogVisible: boolean = false
  isLoading: boolean = false

  isServiceAvailable: boolean = false
  updateServiceAvailabilityTimer: NodeJS.Timer | null = null

  async created() {
    if (isElectron()) {
      this.updateServiceAvailabilityTimer = setInterval(
        this.updateServiceAvailability,
        5 * 1000
      )
      await this.updateServiceAvailability()
    }
  }

  beforeDestroy() {
    if (this.updateServiceAvailabilityTimer) {
      clearInterval(this.updateServiceAvailabilityTimer)
    }
  }

  async updateServiceAvailability() {
    this.isServiceAvailable = await window.ipcRenderer.invoke(
      'is-service-available'
    )
  }

  /* Watchers */
  @Watch('hasLoggedIn')
  async onLoginStateChanged() {
    await this.tournamentModule.clearTournamentCatalog()
    await this.tournamentModule.fetchTournamentCatalog()
    LiveChatAPI.setup()

    this.isLoading = false
  }

  /* Methods */
  onWalletClicked() {
    this.$router.push({
      name: 'PaymentWallet'
    })
  }

  async signIn() {
    try {
      this.isLoading = true
      await this.userModule.signIn()
    } catch (err) {
      // ignore error
    }
  }

  showSearchDialog() {
    return this.layoutModule.setSearchDialogVisible(true)
  }

  // Electron
  close() {
    quit()
  }

  // maximize() {
  //   const { remote } = window.require('electron')
  //   const window = remote.getCurrentWindow()
  //   window.isMaximized() ? window.unmaximize() : window.maximize()
  // }

  minimize() {
    minimize()
  }

  navigationHome() {
    if (this.$route.path !== '/') this.$router.push('/')
  }

  /* Computed Properties */
  get iconSize() {
    return this.$vuetify.breakpoint.mobile ? 36 : 38
  }

  get hasLoggedIn() {
    return this.userModule.hasLoggedIn
  }

  get nickname() {
    return this.userModule.nickname
  }

  get userId() {
    return this.userModule.userId
  }

  get userAvatar() {
    if (!this.userModule.member) return null
    return this.userModule.member.avatar
  }

  get environment() {
    const env = process.env.VUE_APP_MODE || process.env.NODE_ENV || ''
    if (!env || env === 'production') return ''
    return {
      name: env.toUpperCase(),
      color: env === 'development' ? 'orange' : 'yellow'
    }
  }

  get applicationVenue() {
    return this.venueModule.applicationVenue
  }

  get isElectron() {
    return isElectron()
  }
}
